export default __webpack_public_path__ + "static/media/jukedgg.57677a27.png";